import dayjs from 'dayjs';

export const getDaySuffix = (day) => {
  if (day >= 11 && day <= 13) {
    return 'th';
  }
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

// Helper function to format date for monthly SIP display
export const formatMonthlyDate = (date) => {
  if (!date) return '';
  const day = dayjs(date).date();
  return `${day}${getDaySuffix(day)}`;
};
